<template>
    <div class="bg-grid" :style="{transform: moveUp}">
        <svg class="svg-grid" width="1440" height="3221" viewBox="0 0 1440 3221" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 52.4 (67378) - http://www.bohemiancoding.com/sketch -->
            <title>grid@2x</title>
            <desc>Created with Sketch.</desc>
            <g id="LASM-Site-R3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Home-lifestyle-R3">
                    <g id="grid" transform="translate(0.000000, -40.000000)">
                        <g>
                            <g transform="translate(-286.000000, -124.000000)">
                                <path d="M286,503 L1392,1841" id="Path-Copy" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M49,697 C974.911458,1825.49479 1437.86719,2389.74219 1437.86719,2389.74219" id="Path-Copy-4" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M0,1124 L1106,2462" id="Path-Copy-5" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M139.398438,2879.75781 C139.398438,2879.75781 681.932292,2429.50521 1767,1529" id="Path-2" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M252,1973 L1695,776" id="Path-2-Copy" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M193,1900 L1636,703" id="Path-2-Copy-2" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M176,2997 C646,2578 2104,1366 2104,1366" id="Path-2-Copy-3" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M241,3077 C681,2695 2139,1483 2139,1483" id="Path-2-Copy-5" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M209,3454 C731,2971 2189,1759 2189,1759" id="Path-2-Copy-6" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M411,1135 C411,1135 1270.28983,421.302063 1348.39648,359.042969" id="Path-2-Copy-4" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M798,171 L1886,1483" id="Path-Copy-2" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M1051,0 L2139,1312" id="Path-Copy-3" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <path d="M537,335 L1726,1770.20312" id="Path" stroke-opacity="0.15" stroke="#9BB9D4" stroke-width="2"></path>
                                <polygon id="Rectangle-2" fill-opacity="0.15" fill="#9BB9D4" transform="translate(1085.000000, 755.000000) rotate(-40.000000) translate(-1085.000000, -755.000000) " points="931 614 1239 615.579054 1236.84412 894.346086 931.1739 896"></polygon>
                                <polygon id="Rectangle-2-Copy-3" fill-opacity="0.15" fill="#9BB9D4" transform="translate(729.594135, 1282.767574) rotate(-40.000000) translate(-729.594135, -1282.767574) " points="576.780324 1233.16941 883.646217 1236.10286 883.011839 1332.36574 575.542053 1331.20939"></polygon>
                                <polygon id="Rectangle-2-Copy-4" fill-opacity="0.15" fill="#9BB9D4" transform="translate(549.039111, 1547.638494) rotate(-40.000000) translate(-549.039111, -1547.638494) " points="396.895841 1503.7305 701.635615 1508.55663 700.530825 1591.54649 396.442608 1589.55743"></polygon>
                                <polygon id="Rectangle-2-Copy" fill-opacity="0.15" fill="#9BB9D4" transform="translate(1375.441394, 629.612311) rotate(-40.000000) translate(-1375.441394, -629.612311) " points="1223.38319 490.988153 1528.82431 495.649799 1527.44942 768.23647 1222.05848 767.920346"></polygon>
                                <polygon id="Rectangle-2-Copy-2" fill-opacity="0.15" fill="#9BB9D4" transform="translate(1314.487809, 1031.822511) rotate(-40.000000) translate(-1314.487809, -1031.822511) " points="1161.66954 984.204521 1467.87353 985.835529 1467.02298 1079.4405 1161.10209 1077.0293"></polygon>
                            </g>
                        </g>
                        <g id="animated-path" transform="translate(234.000000, 346.000000)" stroke="#40CBD9">
                            <path d="M138,9 L355.578075,273.299567 C357.333146,275.431511 360.484194,275.737028 362.616139,273.981958 C362.623065,273.976256 362.629976,273.970536 362.636871,273.964797 L589.832482,84.8729928 C591.954446,83.1068905 595.106232,83.394831 596.873045,85.5162036 L938.941391,496.227375 C940.708623,498.34925 940.421127,501.501994 938.299252,503.269225 C938.297715,503.270506 938.296177,503.271785 938.294638,503.273064 L243.626358,1080.42573 L2.61157692,1278.15507 C0.476679181,1279.90655 0.165855508,1283.05707 1.91733282,1285.19197 C1.92050782,1285.19584 1.92368863,1285.19971 1.92687524,1285.20357 L680.851563,2107.70312" stroke-width="5" id="draw-path" ref="drawPath"></path>
                            <circle id="Oval" stroke-width="6" fill="#40CBD9" cx="138" cy="10" r="10"></circle>
                        </g>
                        <svg class="big-circle" :class="['pulse-svg', {'show': drawFirst}]" id="point-1" x="781.000000" y="393.000000" width="96" height="96" stroke="#FFFFFF">
                            <circle id="Oval-Copy-6" stroke-width="6" fill="#40CBD9" cx="46" cy="44" r="10"></circle>
                            <circle class="circle first-circle" cx="46" cy="46" r="45"></circle>
                            <circle class="circle second-circle" cx="46" cy="46" r="45"></circle>
                            <circle class="circle third-circle" cx="46" cy="46" r="45"></circle>
                            <circle id="pulse-copy-2" stroke-width="2" cx="46" cy="46" r="45"></circle>
                        </svg>
                        <svg class="big-circle" :class="['pulse-svg', {'show': drawSecond}]" id="point-2" x="705.000000" y="1152.000000" width="96" height="96" stroke="#FFFFFF">
                            <circle id="Oval-Copy-5" stroke-width="6" fill="#40CBD9" cx="46" cy="46" r="10"></circle>
                            <circle class="circle first-circle" cx="46" cy="46" r="45"></circle>
                            <circle class="circle second-circle" cx="46" cy="46" r="45"></circle>
                            <circle class="circle third-circle" cx="46" cy="46" r="45"></circle>
                            <circle id="pulse-copy" stroke-width="2" cx="45" cy="45" r="45"></circle>
                        </svg>
                        <svg class="big-circle" :class="['pulse-svg', {'show': drawThird}]" id="point-3" x="503.000000" y="1969.000000" width="96" height="96" stroke="#FFFFFF">
                            <circle id="Oval-Copy-7" stroke-width="6" fill="#40CBD9" cx="46" cy="46" r="10"></circle>
                            <circle class="circle first-circle" cx="46" cy="46" r="45"></circle>
                            <circle class="circle second-circle" cx="46" cy="46" r="45"></circle>
                            <circle class="circle third-circle" cx="46" cy="46" r="45"></circle>
                            <circle id="pulse-copy-3" stroke-width="2" cx="45" cy="45" r="45"></circle>
                        </svg>
                    </g>
                </g>
            </g>
        </svg>

    </div>
</template>

<script>

    export default {
        name: "Grid",
        data() {
            return {
                pathObj: null,
                lengthPath: 0,
                flag: false,
                scrollPercent: 0,
                drawDot: false,
                drawFirst: false,
                drawSecond: false,
                drawThird: false,
                transform: 0,
            }
        },
        mounted() {
            const pathObj = this.$refs.drawPath;

            this.lengthPath = pathObj.getTotalLength();
            pathObj.style.opacity = 1;
            pathObj.style.strokeDasharray = this.lengthPath;
            pathObj.style.strokeDashoffset = this.lengthPath;

            window.addEventListener('scroll', this.onScroll);
            this.onScroll();
        },
        beforeDestroy(){
            window.removeEventListener('scroll', this.onScroll);
        },
        computed: {
            moveUp() {
                if (!this.transform) return 0;
                return `translateY(${this.transform / 4}px)`;
            },
        },
        methods: {
            onScroll() {
                const pathObj = this.$refs.drawPath;

                this.scrollPercent = (document.body.scrollTop + document.documentElement.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);

                let draw = this.lengthPath * this.scrollPercent;

                this.drawDot = draw > 1;
                this.drawFirst = draw > 599;
                this.drawSecond = draw > 1697;
                this.drawThird = draw > 2867;

                this.transform = -(draw);

                pathObj.style.strokeDashoffset = this.lengthPath - draw;
            },
        },
    }
</script>

<style lang="scss" scoped>
    #draw-path {
        opacity: 0;
    }

    .bg-grid {
        width: 100%;
        height: 3221px;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        overflow: hidden;
        /*transition: all .1s ease-in-out;*/

        @media (max-width: 992px){
            display: none;
        }

        .svg-grid{
            display: block;
            margin: auto;
            width: 100%;
        }
    }

    @mixin circle($circleSize) {
        width: $circleSize;
        height: $circleSize;
        border-radius: $circleSize/2;
    }

    @keyframes pulse-me {
        0% {
            transform: scale(0.5);
            opacity: 0;
        }
        50% {
            opacity: 0.1;
        }
        70% {
            opacity: 0.09;
        }
        100% {
            transform: scale(2);
            opacity: 0;
        }
    }

    .pulse-svg {
        overflow: visible;
        opacity: 0;
        transition: opacity .5s ease-in-out;

        &.show{
            opacity: 1;
        }


        .first-circle {
            opacity: 0;
            fill: #fff;
            transform: scale(0.5);
            transform-origin: center center;
            animation: pulse-me 3s linear infinite;
        }
        .second-circle {
            @extend .first-circle;
            animation-delay: 1s;
        }
        .third-circle {
            @extend .first-circle;
            animation-delay: 2s;
        }
    }
</style>